// extracted by mini-css-extract-plugin
module.exports = {"icon":"Detail_icon__cvS-3","iconDis":"Detail_iconDis__23IoW","addNew":"Detail_addNew__J6tfN"};